import { makeAutoObservable } from 'mobx';
import { validateOrb } from './validateOrb';

export class OrbData {
  candleDuration = 1;
  breakBy = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.breakBy = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateOrb(this.candleDuration);
    return result;
  };
  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      breakBy: this.breakBy,
    };
  };

  //specific methods
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setBreakBy = (number) => {
    this.breakBy = number;
  };
}
